// extracted by mini-css-extract-plugin
export default {"article__box":"ArticleBox_article__box__DWRkv","article__detail":"ArticleBox_article__detail__Ih6Hw"};